module.exports = __webpack_public_path__ + "static/media/regalioriginaliBanner.e2d1b821.png";